import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'forceTarget'
})
export class ForceTargetPipe implements PipeTransform {

  transform(value: string): string {
    //return null;
    let doc = new DOMParser().parseFromString(value, "text/html");

    var links = doc.getElementsByTagName("a");
    for (let i = 0; i < links.length; i++) {
        let link=links[i];
        link.setAttribute("target","fromSpectrum");
    }
    // for (let link:Element in links) {
    //   link.
    //   link.setAttribute("target", "fromSpectrum");
    // }
    return doc.body.innerHTML;
  }

}
